/* Platform-aware cart checkout helpers shared by the full cart and drawer. */
(function () {
  window.EssentialsVault = window.EssentialsVault || {};
  if (window.EssentialsVault.cartCheckoutUi) return;

  const walletTags = {
    apple_pay: 'shopify-apple-pay-button',
    google_pay: 'shopify-google-pay-button',
  };

  function preferredWallet() {
    const ua = window.navigator?.userAgent || '';
    const iPadDesktopMode = window.navigator?.platform === 'MacIntel'
      && window.navigator?.maxTouchPoints > 1;
    if (/iPad|iPhone|iPod/i.test(ua) || iPadDesktopMode) return 'apple_pay';
    if (/Android/i.test(ua)) return 'google_pay';
    return null;
  }

  function sync(root) {
    if (!root?.querySelectorAll) return;
    const wallet = preferredWallet();

    root.querySelectorAll('[data-checkout-wallets] [wallet-configs]').forEach((checkout) => {
      const raw = checkout.getAttribute('wallet-configs');
      try {
        const configs = JSON.parse(raw || '[]');
        // Keep the existing platform policy, including Apple Pay on Apple devices.
        const filtered = configs.filter((config) => !wallet || config?.name === wallet);
        const next = JSON.stringify(filtered);
        const wrapper = checkout.closest('[data-checkout-wallets]');
        wrapper.hidden = filtered.length === 0;
        wrapper.style.display = filtered.length ? '' : 'none';
        if (raw !== next) {
          // Shopify builds its closed-shadow grid once. Removing a light-DOM
          // wallet afterward leaves that wallet's empty row in the grid.
          // Connect a fresh native host with the filtered configuration so the
          // provider creates only the slots it will actually display.
          const replacement = checkout.cloneNode(false);
          replacement.setAttribute('wallet-configs', next);
          checkout.replaceWith(replacement);
          return;
        }
      } catch (_) {
        // Shopify owns this payload. If its format changes, leave it intact.
      }
    });
  }

  function watch(root) {
    sync(root);
    if (typeof window.MutationObserver !== 'function') return null;
    const observer = new window.MutationObserver(() => sync(root));
    observer.observe(root, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['wallet-configs'],
    });
    return observer;
  }

  window.EssentialsVault.cartCheckoutUi = { preferredWallet, sync, watch };
})();
